module.exports = __webpack_public_path__ + "img/947325697.ecdb6219.jpg";